import { useState, useCallback } from "react";
import { useIonViewWillEnter, useIonViewWillLeave } from "@ionic/react";
import { MappedAreaModel } from "../models/mapped-area-model";
import { useAnnotationFormContext } from "../contexts/annotation-form.context";
import { useUserContext } from "../../user/contexts/user.context";
import { MappedAreaService } from "../services/mapped-area.service";
import { AssetAncestorModel } from "../models/asset-ancestor-model";

export const useMappedArea = (getPlan: () => Promise<MappedAreaModel>) => {
  const [mappedArea, setMappedArea] = useState<null | MappedAreaModel>(null);
  const { setAnnotationFormVisibility } = useAnnotationFormContext();
  const { currentOrganization } = useUserContext();

  useIonViewWillEnter(() => {
    getPlan().then(setMappedArea);
  });

  useIonViewWillLeave(() => {
    setAnnotationFormVisibility(false);
  });

  const getAssetAncestors = useCallback(
    async (assetId: string): Promise<AssetAncestorModel[]> => {
      if (!currentOrganization) {
        throw new Error("Organization not loaded");
      }
      const orgaCode = currentOrganization.code;
      return MappedAreaService.getAssetAncestors(orgaCode, assetId);
    },
    [currentOrganization]
  );

  return { 
    mappedArea,
    getAssetAncestors,
  };
};
